<template>
	<div class="container">
		<topNav/>
		<div class="state w1200">
			<h3 class="my-h3">在线签约系统</h3>
			<img v-if="status === 2" src="../../assets/image/signed.png" class="state-img" alt="">
			<img v-if="status === 1" src="../../assets/image/signed.png" class="state-img" alt="">
			<p v-if="status === 2">该签约已作废，请重新联系学生获取签约链接</p>
			<p v-if="status === 1">该学生已在签约中，不可重复签约</p>
			<router-link :to="`/login/${su_number}`" class="to-login">登录查看签约历史</router-link>
		</div>
		<Footer/>
	</div>
</template>

<script>
	import { isSign } from '@/api/login'
	import topNav from '../layout/top'
	import Footer from '../layout/footer'
	export default {
		data(){
			return{
				status:1,
				su_number:null
			}
		},
		created(){
			if (this.$route.params.id) {
				this.su_number = this.$route.params.id
				this.isSign()
			}else{
				this.$message({
					message: '未携带签约码',
					type:'error'
				})
			}
		},
		methods:{
			async isSign() {
				const res = await isSign(this.su_number)
				if (res) {
					if(res.state === 0){
						this.$router.push('/sign/'+ this.su_number)
					}else{
						this.status = res.state
					}
				}
			},
		},
		components: {
			topNav,
			Footer
		},
	}
</script>

<style scoped>
	.state{
		text-align: center;
		margin-bottom: 14rem;
	}
	.state-img{
		margin: 6.8125rem 0 1.25rem;
		width: 6rem;
	}
	p{
		font-size: 1.25rem;
		color: #333;
	}
	.to-login{
		display: inline-block;
		margin-top: 1.5625rem;
		padding: 0.375rem 1.5625rem;
		border-radius: 0.1875rem;
		color: #fff;
		background:#5E4FFF ;
	}
	@media (max-width:46.875rem){
		.state-img{
			margin: 2rem 0 1.25rem;
			width: 6rem;
		}
		p{
			font-size: 1rem;
		}
	}
</style>
